import { render } from "./VideoControlls.vue?vue&type=template&id=323549f8&scoped=true"
import script from "./VideoControlls.vue?vue&type=script&lang=js"
export * from "./VideoControlls.vue?vue&type=script&lang=js"

import "./VideoControlls.vue?vue&type=style&index=0&id=323549f8&lang=scss&scoped=true"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323549f8"]])

export default __exports__